import 'reflect-metadata'
import * as React from 'react'
import App from 'next/app'
import '@way/components/styles.scss'
import '@way/app-page-builder/src/theme/styles.scss'

export default class MyApp extends App {
  public render() {
    const { Component, pageProps } = this.props

    return <Component {...pageProps} />
  }
}
